module.exports = __webpack_public_path__ + "b16848209b48b1ce4e95aed6ccb91cf3.svg";